import ROLES from '@/js/constants/roles';

export const user = (state) => state.user;

export const isLogged = (state) => Object.keys(state.user).length > 0;

export const isLoggedSynthetic = (state) => Object.keys(state.user).length > 0
    && state.user.roleType === ROLES.SYNTHETIC;
